import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { statusObj } from 'src/app/dummy/status';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { ICurricular } from 'src/app/interfaces/country';
import { pageKey, checkExist, validSelected, pushToArray, autoComplete } from 'src/app/services/mapping.service';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { List } from 'src/app/stores/administrator/list.store';
import { Master } from 'src/app/stores/administrator/master.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-curricular',
  templateUrl: './add-curricular.component.html',
  styleUrls: ['./add-curricular.component.scss']
})
export class AddCurricularComponent implements OnInit {
  @ViewChild('focusInput', { static: false }) inputEl: ElementRef;

  form: FormGroup;
  name: AbstractControl;
  major: AbstractControl;

  filteredStates: Observable<any[]>;
  constructor(public dialogRef: MatDialogRef<AddCurricularComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
        public auth: AuthStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    public store: List,
    private master: Master,
  ) { }

  buildForm(): void {
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required]), checkExist(this.ds.dbRef(), "curricular", "name")],
      major: [null, Validators.compose([Validators.required, validSelected.bind(this)])],
    });
    this.name = this.form.controls['name'];
    this.major = this.form.controls['major'];
  }

  async ngOnInit() {
    this.buildForm();
    const countries = await this.ds.majorRef(ref => ref.where("facultyKey", "==", this.master.SELECTED_FACULTY).orderBy('name')).get().toPromise();
    this.filteredStates = autoComplete(this.major, pushToArray(countries), 'name');
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.key === o2.key : o1 === o2;
  }


  displayItem(item: any): string {
    return item ? item.name : item;
  }

  create(f: any, isNew) {
    if (this.form.valid) {
      const { name, major } = f;
      const { SELECTED_PROGRAM } = this.master;
      const batch = this.ds.batch();
      const item: ICurricular = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        name: name,
        status: statusObj.active,
        degreeRef: this.ds.degreeRef().doc(SELECTED_PROGRAM).ref,
        degreeKey: SELECTED_PROGRAM,
        majorRef: this.ds.majorRef().doc(major.key).ref,
        majorKey: major.key,
        levelRef: this.ds.levelRef().doc(major.levelKey).ref,
        levelKey: major.levelKey,
        facultyRef: this.ds.facultyRef().doc(major.facultyKey).ref,
        facultyKey: major.facultyKey
      }
      batch.set(this.ds.curricularFireRef().doc(item.key), item);
      batch.update(this.ds.majorFireRef().doc(major.key), {
        [`${SELECTED_PROGRAM}Ref`]: this.ds.curricularRef().doc(item.key).ref,
        [`${SELECTED_PROGRAM}`]: item.key,
      })
      this.store.saveBatch(batch, (success, error) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Curricular has been created successfully.', 'Done', { duration: 3000 });
          this.form.reset();
          this.inputEl.nativeElement.focus();
        } else {
          this.snackBar.open(error, 'Error');
        }
      });
    }
  }

}
